import type * as React from 'react'

import { XIcon, IconButton, MenuIcon, StatusDot } from '@buffer-mono/popcorn'

import styles from './MobileTopbar.module.css'

import type { JSX } from 'react'

type MobileTopbarShellProps = {
  navigationOpen: boolean
  onNavigationOpenChange: (open: boolean) => void
  logo: React.ReactNode
  rightContent?: React.ReactNode
  showBadge?: boolean
  openMenuLabel?: string
  openMenuBadgeLabel?: string
}

export function MobileTopbarShell({
  navigationOpen,
  onNavigationOpenChange,
  logo,
  rightContent,
  showBadge = false,
  openMenuLabel = 'Open menu',
  openMenuBadgeLabel = openMenuLabel,
}: MobileTopbarShellProps): JSX.Element {
  return (
    <header className={styles.topbar}>
      <div className={styles.leftSection}>
        <div className={styles.menuButtonWrapper}>
          <IconButton
            variant="tertiary"
            size="large"
            label={
              navigationOpen
                ? 'Close menu'
                : showBadge
                  ? openMenuBadgeLabel
                  : openMenuLabel
            }
            aria-expanded={navigationOpen}
            aria-controls="mobile-navigation-drawer"
            onClick={(): void => onNavigationOpenChange(!navigationOpen)}
          >
            {navigationOpen ? (
              <XIcon className={styles.menuIcon} />
            ) : (
              <MenuIcon className={styles.menuIcon} />
            )}
          </IconButton>
          {showBadge && (
            <StatusDot className={styles.badgeDot} aria-hidden="true" />
          )}
        </div>
        {logo}
      </div>
      {rightContent ? (
        <div className={styles.rightSection}>{rightContent}</div>
      ) : null}
    </header>
  )
}
